import { isDayjs } from 'dayjs';
export var getDateToRender = function (isOverdue, date, overdueText, dayjsFormatter) {
    var dte;
    if (isOverdue) {
        dte = overdueText || 'Overdue';
    }
    else if (!date) {
        dte = '--';
    }
    else if (isDayjs(date)) {
        dayjsFormatter = dayjsFormatter || 'MM/DD/YYYY';
        if (typeof dayjsFormatter === 'function') {
            dte = dayjsFormatter(date);
        }
        else {
            dte = date.format(dayjsFormatter);
        }
    }
    else {
        dte = date;
    }
    return dte;
};
//# sourceMappingURL=DataGridColumnDate.utilities.js.map